import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPin = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12 2C9.794 2 8 3.794 8 6C8 7.86842 9.29313 9.42761 11.0273 9.86523C11.0208 9.91131 11 9.95213 11 10V21C11 21.552 11.448 22 12 22C12.552 22 13 21.552 13 21V10C13 9.95213 12.9792 9.91131 12.9727 9.86523C14.7069 9.42761 16 7.86842 16 6C16 3.794 14.206 2 12 2Z",
		fill: "currentColor"
	})
});
export default SvgPin;
